module.exports = __webpack_public_path__ + "static/media/LargeBottleCircleNot.112ca2f9.png";